import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation()
  return (
    <footer className="w-full border-t border-neutral-200 bg-white mt-auto">
      <div className="container-custom py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <span className="font-serif text-lg font-light text-neutral-900 tracking-tight">
              NEST
            </span>
            <span className="text-sm text-neutral-500 uppercase tracking-wide">
              {t('footer.rentalApartments')}
            </span>
          </div>
          <div className="flex items-center gap-6 text-sm text-neutral-500">
            <div className="flex items-center gap-2">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
              <span className="uppercase tracking-wide text-xs">{t('footer.secure')}</span>
            </div>
            <span className="uppercase tracking-wide text-xs">{t('footer.poweredBy')}</span>
            <div className="flex items-center gap-2">
              <svg className="w-8 h-5" viewBox="0 0 48 32" fill="none">
                <rect width="48" height="32" rx="0" fill="#1A1F71" />
                <text
                  x="24"
                  y="20"
                  textAnchor="middle"
                  fill="white"
                  fontSize="10"
                  fontWeight="bold"
                >
                  VISA
                </text>
              </svg>
              <svg className="w-8 h-5" viewBox="0 0 48 32" fill="none">
                <rect width="48" height="32" rx="0" fill="#EB001B" />
                <circle cx="20" cy="16" r="10" fill="#EB001B" />
                <circle cx="28" cy="16" r="10" fill="#F79E1B" />
                <path d="M24 8.5a10 10 0 000 15" fill="#FF5F00" />
              </svg>
            </div>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-neutral-100 text-center text-xs text-neutral-400 uppercase tracking-wide">
          <p>{t('footer.rights', { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  )
}
